/* Retail Fixtures Co — header (priority nav, sticky search row, mobile menu), gondola run builder, accordions, quote form (v2 2-10-2026). */
(function () {
  var hdr = document.querySelector('[data-rfc-hdr]');

  /* mobile menu: focus moves in, Tab stays inside, Escape/scrim/close button return focus to the menu button, page behind does not scroll */
  var drawer = document.querySelector('[data-rfc-drawer]'), open = document.querySelector('[data-rfc-open]');
  if (drawer && open) {
    var panel = drawer.querySelector('[role="dialog"]');
    var focusables = function () { return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])')); };
    var close = function () {
      if (drawer.hidden) return;
      drawer.hidden = true; open.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = ''; document.body.style.overflow = '';
      open.focus();
    };
    open.addEventListener('click', function () {
      drawer.hidden = false; open.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
      var b = drawer.querySelector('[data-rfc-close]'); if (b) b.focus();
    });
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-rfc-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) close(); });
  }

  /* department nav: show every link that fits; the rest move into "More departments" (click/keyboard, not hover) */
  var nav = document.querySelector('[data-rfc-nav]');
  if (nav) {
    var list = nav.querySelector('[data-rfc-nav-list]'), more = nav.querySelector('[data-rfc-more]'), btn = nav.querySelector('[data-rfc-more-btn]');
    var menu = more ? more.querySelector('.rfc-nav__menu') : null;
    var items = Array.prototype.slice.call(list.children), extras = menu ? Array.prototype.slice.call(menu.children) : [];
    var setMenu = function (show) {
      if (!menu) return;
      menu.hidden = !show; btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    };
    var fit = function () {
      if (!more || nav.offsetParent === null) return;
      setMenu(false);
      items.forEach(function (li) { li.hidden = false; });
      extras.forEach(function (li) { li.hidden = true; });
      more.hidden = true; nav.classList.remove('is-fit'); if (btn) btn.classList.remove('has-current');
      if (list.scrollWidth <= list.clientWidth + 1) { nav.classList.add('is-fit'); return; }
      more.hidden = false;
      for (var i = items.length - 1; i > 0 && list.scrollWidth > list.clientWidth + 1; i--) {
        items[i].hidden = true; extras[i].hidden = false;
      }
      nav.classList.add('is-fit');
      btn.classList.toggle('has-current', !!menu.querySelector('li:not([hidden]) a[aria-current]'));
    };
    if (btn) {
      btn.addEventListener('click', function () {
        var show = menu.hidden; setMenu(show);
        if (show) { var a = menu.querySelector('li:not([hidden]) a'); if (a) a.focus(); }
      });
      more.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) { e.preventDefault(); setMenu(false); btn.focus(); }
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !menu.hidden) {
          var links = Array.prototype.slice.call(menu.querySelectorAll('li:not([hidden]) a')), i = links.indexOf(document.activeElement);
          if (!links.length) return;
          e.preventDefault();
          i = e.key === 'ArrowDown' ? (i + 1) % links.length : (i <= 0 ? links.length - 1 : i - 1);
          links[i].focus();
        }
      });
      document.addEventListener('click', function (e) { if (!menu.hidden && !more.contains(e.target)) setMenu(false); });
      more.addEventListener('focusout', function (e) { if (e.relatedTarget && !more.contains(e.relatedTarget)) setMenu(false); });
    }
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 100); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }

  /* compact sticky search row once the header has scrolled away */
  if (hdr && hdr.hasAttribute('data-rfc-sticky')) {
    var main = hdr.querySelector('[data-rfc-main]'), ph = hdr.querySelector('[data-rfc-ph]');
    var stuck = false, ticking = false;
    var limit = function () { var r = hdr.getBoundingClientRect(); return r.bottom + window.scrollY; };
    var check = function () {
      ticking = false;
      var want = window.scrollY > limit() + 40;
      if (want === stuck) return;
      if (want) { hdr.style.setProperty('--rfc-mh', main.offsetHeight + 'px'); }
      stuck = want; hdr.classList.toggle('is-stuck', want);
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }

  /* gondola run builder */
  var f = document.querySelector('[data-rfc-gb]');
  var dataEl = document.querySelector('[data-rfc-gb-data]');
  if (f && dataEl) {
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { bays: [] }; }
    var out = f.querySelector('[data-rfc-gb-out]');
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
    var val = function (n) { var el = f.querySelector('[name="' + n + '"]:checked') || f.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
    var txt = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el && el.options ? el.options[el.selectedIndex].text : ''; };
    var pl = function (n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); };
    var show = function (scroll) {
      var h = val('rfc-h'), d = val('rfc-d'), lay = val('rfc-l');
      var n = Math.max(1, Math.min(60, parseInt(val('rfc-n'), 10) || 1));
      var ends = parseInt(val('rfc-e'), 10) || 0;
      var sum = '<ul class="rfc-gb__sum" aria-label="Your selection"><li>' + esc(h) + ' m high</li><li>' + esc(d) + ' mm base</li><li>' + esc(txt('rfc-l')) + '</li><li>' + pl(n, 'bay') + '</li><li>' + (ends ? pl(ends, 'end promo bay') : 'No end bays') + '</li></ul>';
      var sec = function (withWall) {
        var l = [];
        if (withWall) l.push('<a href="' + esc(data.wall) + '">Wall shelving</a>');
        if (ends) l.push('<a href="' + esc(data.ends) + '">End bays</a>');
        l.push('<a href="' + esc(data.acc) + '">Shelving accessories</a>');
        return '<div class="rfc-gb__links"><span>Also for this run:</span>' + l.join('') + '</div>';
      };
      var html = sum;
      if (lay === 'wall') {
        html += '<p class="rfc-gb__msg"><b>Wall run: ' + pl(n, 'single-sided bay') + '.</b> Single-sided bays are in our wall shelving range — choose the height and depth there.</p>' +
          '<div class="rfc-gb__go"><a class="rfc-btn rfc-btn--dark" href="' + esc(data.wall) + '">Shop wall shelving</a><p>Next: pick a ' + esc(h) + ' m bay with a ' + esc(d) + ' mm base, then set the quantity to ' + n + '.</p></div>' + sec(false);
      } else {
        var bay = (data.bays || []).filter(function (b) { return String(b.h) === h && String(b.d) === d; })[0];
        if (bay) {
          html += '<a class="rfc-gb__res" href="' + esc(bay.url) + '">' + (bay.img ? '<img src="' + esc(bay.img) + '" alt="" loading="lazy" width="76" height="76">' : '<i aria-hidden="true"></i>') +
            '<span><small>Matching bay</small><b>' + esc(bay.title) + '</b></span></a>' +
            '<div class="rfc-gb__go"><a class="rfc-btn rfc-btn--dark" href="' + esc(bay.url) + '">Configure this bay</a><p>Next: choose bay width, shelves and colour, then set the quantity to ' + n + '.</p></div>' + sec(false);
        } else {
          html += '<p class="rfc-gb__msg">We don\'t list a ' + esc(h) + ' m bay with a ' + esc(d) + ' mm base yet — <a class="rfc-u" href="#rfc-quote">ask us for a quote</a>.</p>' + sec(false);
        }
      }
      out.innerHTML = html;
      out.hidden = false;
      if (scroll && out.getBoundingClientRect().bottom > window.innerHeight) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    var go = f.querySelector('[data-rfc-gb-go]');
    if (go) go.addEventListener('click', function () { show(true); });
    f.addEventListener('change', function () { if (!out.hidden) show(false); });
    f.addEventListener('input', function (e) { if (e.target.name === 'rfc-n' && !out.hidden) show(false); });
  }

  /* accordions: open on desktop (summary inert), collapsible on phones */
  var accs = Array.prototype.slice.call(document.querySelectorAll('[data-rfc-acc]'));
  if (accs.length) {
    var mq = window.matchMedia('(max-width: 749px)');
    var apply = function () {
      accs.forEach(function (d) {
        var s = d.querySelector('summary');
        if (mq.matches) { d.open = false; s.removeAttribute('tabindex'); s.removeAttribute('aria-disabled'); }
        else { d.open = true; s.setAttribute('tabindex', '-1'); }
      });
    };
    accs.forEach(function (d) { d.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); }); });
    mq.addEventListener('change', apply); apply();
  }

  /* quote form: inline messages under required fields (native validation still applies) */
  Array.prototype.slice.call(document.querySelectorAll('form[data-rfc-validate]')).forEach(function (form) {
    var msg = function (el) {
      if (el.validity.valueMissing) return el.type === 'email' ? 'Enter your email address.' : 'Tell us what you need.';
      if (el.validity.typeMismatch) return 'Enter an email address like name@business.co.uk.';
      return '';
    };
    var set = function (el) {
      var id = el.getAttribute('aria-describedby'), p = id ? document.getElementById(id) : null, m = msg(el);
      if (m) { el.setAttribute('aria-invalid', 'true'); } else { el.removeAttribute('aria-invalid'); }
      if (p) { p.textContent = m; p.hidden = !m; }
    };
    form.addEventListener('invalid', function (e) { set(e.target); }, true);
    form.addEventListener('input', function (e) { if (e.target.hasAttribute('aria-invalid')) set(e.target); });
    form.addEventListener('submit', function (e) {
      var bad = Array.prototype.slice.call(form.querySelectorAll('[required]')).filter(function (el) { set(el); return !el.checkValidity(); });
      if (bad.length) { e.preventDefault(); bad[0].focus(); }
    });
  });

  /* quote form result into view */
  var ok = document.querySelector('[data-rfc-focus]');
  if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
})();

/* collection page (v2 2-10-2026): filters, price select, sort, load more, filter drawer, add-to-basket busy state, quote link focus */
(function () {
  var root = document.querySelector('[data-rfc-col]');
  if (!root) return;
  var go = function (u) { u.searchParams.delete('page'); u.hash = 'rfc-products'; location.href = u.toString(); };

  /* sidebar filter form (only rendered when list filters exist) */
  var form = root.querySelector('[data-rfc-filter-form]');
  var submit = function () {
    if (!form) return;
    var url = new URL(form.action, location.href);
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled || el.name === 'rfc-price') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' && el.type === 'hidden') return;
      params.append(el.name, el.value);
    });
    location.href = url.pathname + (params.toString() ? '?' + params.toString() : '') + '#rfc-products';
  };
  if (form) {
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (r.name === 'rfc-price') {
        var box = r.closest('[data-rfc-price]');
        box.querySelector('[data-rfc-gte]').value = r.getAttribute('data-gte') || '';
        box.querySelector('[data-rfc-lte]').value = r.getAttribute('data-lte') || '';
      }
      submit();
    });
  }

  /* toolbar price select (when price is the only filter): keeps sort and any other parameters */
  var psel = root.querySelector('[data-rfc-price-sel]');
  if (psel) psel.addEventListener('change', function () {
    var u = new URL(location.href), parts = psel.value.split('|');
    var g = psel.getAttribute('data-gte-name'), l = psel.getAttribute('data-lte-name');
    u.searchParams.delete(g); u.searchParams.delete(l);
    if (parts[0]) u.searchParams.set(g, parts[0]);
    if (parts[1]) u.searchParams.set(l, parts[1]);
    go(u);
  });
  var sort = root.querySelector('[data-rfc-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); go(u); });

  /* back/forward cache: show the state the page was rendered with, not a half-changed control */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    root.querySelectorAll('select').forEach(function (s) { for (var i = 0; i < s.options.length; i++) { if (s.options[i].defaultSelected) { s.selectedIndex = i; break; } } });
    root.querySelectorAll('input[type=radio], input[type=checkbox]').forEach(function (c) { c.checked = c.defaultChecked; });
    root.querySelectorAll('[data-rfc-add] button').forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); var l = b.querySelector('[data-rfc-add-l]'); if (l) l.textContent = 'Add to basket'; });
  });

  /* add to basket: normal form post to /cart/add, with a busy state so it is not sent twice */
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rfc-add]'); if (!f) return;
    var b = f.querySelector('button[type=submit]');
    if (b.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    b.setAttribute('aria-busy', 'true'); var l = b.querySelector('[data-rfc-add-l]'); if (l) l.textContent = 'Adding…';
    setTimeout(function () { b.disabled = true; }, 0);
  });

  /* load more */
  var more = root.querySelector('[data-rfc-more]'), grid = root.querySelector('[data-rfc-grid]');
  if (more && grid && window.fetch && window.DOMParser) {
    more.addEventListener('click', function (e) {
      e.preventDefault();
      if (more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true'); more.textContent = 'Loading…';
      fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-rfc-grid] > li');
        var firstNew = null;
        Array.prototype.forEach.call(items, function (li) { var n = document.importNode(li, true); if (!firstNew) firstNew = n; grid.appendChild(n); });
        var total = parseInt(more.getAttribute('data-total'), 10) || 0, shown = grid.children.length;
        var c = root.querySelector('[data-rfc-shown]'); if (c) c.textContent = 'Showing ' + shown + ' of ' + total;
        var bar = root.querySelector('[data-rfc-bar]'); if (bar && total) bar.style.width = Math.round(shown * 100 / total) + '%';
        var next = doc.querySelector('[data-rfc-more]');
        if (next) { more.href = next.href; more.textContent = next.textContent; more.removeAttribute('aria-busy'); }
        else { more.closest('.rfc-more-wrap').remove(); }
        if (firstNew) { var a = firstNew.querySelector('h3 a'); if (a) a.focus({ preventScroll: true }); }
      }).catch(function () { location.href = more.href; });
    });
  }

  /* "Need a bulk quote?" → quote form, focus the first field */
  var ql = root.querySelector('[data-rfc-quote-link]');
  if (ql) ql.addEventListener('click', function () {
    var f = document.getElementById('rfc-pn') || root.querySelector('#rfc-project input:not([type=hidden]), #rfc-project textarea');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 450);
  });

  /* filter drawer (phones/tablets, only when there is a sidebar) */
  var filt = root.querySelector('[data-rfc-filt]'), scrim = root.querySelector('[data-rfc-filt-scrim]'), op = root.querySelector('[data-rfc-filt-open]');
  if (filt && op && scrim) {
    var isOpen = function () { return filt.classList.contains('is-open'); };
    var closeF = function () { if (!isOpen()) return; filt.classList.remove('is-open'); scrim.hidden = true; op.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; filt.removeAttribute('role'); filt.removeAttribute('aria-modal'); op.focus(); };
    op.addEventListener('click', function () {
      filt.classList.add('is-open'); scrim.hidden = false; op.setAttribute('aria-expanded', 'true');
      filt.setAttribute('role', 'dialog'); filt.setAttribute('aria-modal', 'true');
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
      var x = filt.querySelector('[data-rfc-filt-close]'); if (x) x.focus();
    });
    scrim.addEventListener('click', closeF);
    filt.querySelectorAll('[data-rfc-filt-close]').forEach(function (x) { x.addEventListener('click', closeF); });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { e.preventDefault(); closeF(); return; }
      if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(filt.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select'));
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) closeF(); });
  }
})();

/* product page (v3 2-10-2026): option pills (incl. height × length split), price each / VAT / quantity total, drawings, planner, gallery + lightbox, qty, add-to-basket feedback, quick-buy bar, quote prefill */
(function () {
  var root = document.querySelector('[data-rfc-pdp]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var product; try { product = JSON.parse($('[data-rfc-product]').textContent); } catch (e) { return; }
  var fmt = root.getAttribute('data-money') || '£{{amount}}';
  var vatMode = 'inc';
  var unitCents = function (c) { return vatMode === 'ex' ? Math.round(c / 1.2) : c; };
  var fmtC = function (c) {
    var n = (c / 100).toFixed(2).split('.');
    var amt = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).split(' (')[0].split(' Inc')[0].split(' inc')[0];
  };
  var money = function (c) { return fmtC(unitCents(c)); };
  var vatWord = function () { return vatMode === 'ex' ? 'ex VAT' : (root.getAttribute('data-taxes-included') === 'false' ? 'ex VAT' : 'inc VAT'); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var idSel = $('[data-rfc-id]');
  var variants = product.variants || [];
  var current = variants.filter(function (x) { return String(x.id) === idSel.value; })[0] || variants[0];
  var optNames = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  var hl = {};
  (root.getAttribute('data-hlabels') || '').split(';').forEach(function (p) { var kv = p.split('='); if (kv.length === 2) hl[parseFloat(kv[0])] = kv[1].trim(); });

  var toMM = function (n, u) { n = parseFloat(n); if (u && u.toLowerCase() === 'm' && n < 50) return n * 1000; return n; };
  var pair = function (v) {
    var m = String(v).match(/^\s*([\d.]+)\s*(mm|m)?\s*[x×]\s*([\d.]+)\s*(mm|m)?/i);
    return m ? [toMM(m[1], m[2] || m[4]), toMM(m[3], m[4])] : null;
  };
  var lenOf = function (v) { var m = String(v).match(/([\d.]+)\s*(mm|m)\b/i); return m ? toMM(m[1], m[2]) : null; };
  var fmtM = function (mm) { return (mm >= 1000 || mm % 100 === 0) ? (+(mm / 1000).toFixed(2)) + 'm' : mm + 'mm'; };
  var hoopIcon = function (h, max) { var t = 6 + Math.round(16 * h / max); return '<svg width="30" height="24" viewBox="0 0 30 24" aria-hidden="true"><path d="M7 22V' + (22 - t + 4) + 'q0-4 4-4h8q4 0 4 4V22" fill="none" stroke="currentColor" stroke-width="2.4"/><path d="M3 22h24" stroke="currentColor" stroke-width="1.4"/></svg>'; };

  var opts = optNames.map(function (name, i) {
    var vals = []; variants.forEach(function (x) { if (vals.indexOf(x.options[i]) < 0) vals.push(x.options[i]); });
    var split = vals.length > 1 && vals.every(function (v) { return pair(v); });
    var labels = ['Height', 'Length'];
    var pm = name.match(/\(([^)]+)\)/);
    if (pm && /\sx\s/i.test(pm[1])) labels = pm[1].split(/\s+x\s+/i).map(function (s) { s = s.trim(); return s.charAt(0).toUpperCase() + s.slice(1); });
    return { name: name, i: i, vals: vals, split: split, labels: labels };
  });
  var single = variants.length === 1 && /default/i.test(variants[0].title);
  var sel = current ? current.options.slice() : [];

  var box = $('[data-rfc-opts]');
  var render = function () {
    if (single) { box.innerHTML = ''; return; }
    var html = '', step = 0;
    opts.forEach(function (o) {
      if (o.split) {
        var cur = pair(sel[o.i]) || [];
        var as = [], bs = {}, allB = [];
        o.vals.forEach(function (v) { var p = pair(v); if (as.indexOf(p[0]) < 0) as.push(p[0]); (bs[p[0]] = bs[p[0]] || []).push(p[1]); if (allB.indexOf(p[1]) < 0) allB.push(p[1]); });
        as.sort(function (x, y) { return x - y; }); allB.sort(function (x, y) { return x - y; });
        var maxA = as[as.length - 1];
        var aLabel = o.labels[0] || 'Size';
        if (/^height$/i.test(aLabel) && Object.keys(hl).length) aLabel = 'Height above ground';
        html += '<fieldset class="rfc-og"><legend>' + (++step) + ' · ' + esc(aLabel) + '</legend><div class="rfc-og__p rfc-og__p--3">';
        as.forEach(function (a) {
          var n = bs[a].length, sub = hl[a] || (n + ' ' + (o.labels[1] || 'size').toLowerCase() + (n === 1 ? '' : 's'));
          html += '<button type="button" class="rfc-pill' + (Object.keys(hl).length ? ' rfc-pill--ic' : '') + (a === cur[0] ? ' is-on' : '') + '" aria-pressed="' + (a === cur[0]) + '" data-o="' + o.i + '" data-a="' + a + '">' + (Object.keys(hl).length ? hoopIcon(a, maxA) : '') + '<b>' + a + 'mm</b><small>' + esc(sub) + '</small></button>';
        });
        html += '</div></fieldset><fieldset class="rfc-og"><legend>' + (++step) + ' · ' + esc(o.labels[1] || 'Size') + '</legend><div class="rfc-og__p rfc-og__p--4">';
        allB.forEach(function (b) {
          var ok = (bs[cur[0]] || []).indexOf(b) >= 0;
          html += '<button type="button" class="rfc-pill' + (b === cur[1] ? ' is-on' : '') + (ok ? '' : ' is-na') + '" aria-pressed="' + (b === cur[1]) + '" data-o="' + o.i + '" data-b="' + b + '"' + (ok ? '' : ' aria-disabled="true"') + '><b>' + fmtM(b) + '</b><small>' + b + 'mm</small></button>';
        });
        html += '</div></fieldset>';
      } else {
        html += '<fieldset class="rfc-og"><legend>' + (++step) + ' · ' + esc(o.name) + '</legend><div class="rfc-og__p">';
        o.vals.forEach(function (v) {
          var test = sel.slice(); test[o.i] = v;
          var ok = variants.some(function (x) { return x.options.every(function (y, k) { return y === test[k]; }); });
          html += '<button type="button" class="rfc-pill rfc-pill--txt' + (v === sel[o.i] ? ' is-on' : '') + (ok ? '' : ' is-na') + '" aria-pressed="' + (v === sel[o.i]) + '" data-o="' + o.i + '" data-v="' + esc(v) + '">' + esc(v) + '</button>';
        });
        html += '</div></fieldset>';
      }
    });
    box.innerHTML = html;
  };

  var findV = function () { return variants.filter(function (x) { return x.options.every(function (y, k) { return y === sel[k]; }); })[0]; };
  var add = $('[data-rfc-add]'), now = $('[data-rfc-now]'), price = $('[data-rfc-price]'), selLine = $('[data-rfc-sel]'), qty = $('[data-rfc-qty]');
  var sbar = document.querySelector('[data-rfc-sbar]'), sAdd = sbar && sbar.querySelector('[data-rfc-sbar-add]');
  var busy = false;
  var qn = function () { var n = parseInt(qty.value, 10); return n >= 1 ? Math.min(n, 999) : 1; };
  var setAddLabel = function () {
    if (current && current.available && !busy) add.innerHTML = '<span>Add <span data-rfc-addn>' + qn() + '</span> to basket</span>';
    var o = sbar && sbar.querySelector('[data-rfc-sbar-opt]'); if (o && current) o.textContent = (single ? '' : current.title + ' · ') + 'Qty ' + qn();
    if (sAdd && current) { sAdd.disabled = !current.available || busy; if (!busy) sAdd.textContent = current.available ? 'Add to basket' : 'Sold out'; }
    showTotal();
  };
  var showTotal = function () {
    var t = $('[data-rfc-total]'); if (!t || !current) return;
    var q = qn();
    if (q > 1) { t.hidden = false; t.innerHTML = 'Total for ' + q + ': <b>' + fmtC(unitCents(current.price) * q) + '</b> ' + vatWord(); }
    else t.hidden = true;
  };
  var showPrice = function () {
    if (current) price.textContent = money(current.price);
    var l = $('[data-rfc-vatlbl]'); if (l) l.textContent = vatMode === 'ex' ? 'excl. VAT' : (root.getAttribute('data-taxes-included') === 'false' ? 'excl. VAT' : 'incl. VAT');
    $$('[data-rfc-cents]').forEach(function (e) { e.textContent = money(parseInt(e.getAttribute('data-rfc-cents'), 10) || 0); });
    $$('[data-rfc-vatw]').forEach(function (e) { e.textContent = vatWord(); });
    if (sbar && current) { sbar.querySelector('[data-rfc-sbar-price]').textContent = money(current.price); sbar.querySelector('[data-rfc-sbar-vat]').textContent = vatMode === 'ex' ? 'excl. VAT' : 'incl. VAT'; }
    showTotal();
  };
  var update = function (pushUrl) {
    var v = findV();
    if (!v) { add.disabled = true; add.textContent = 'Not available'; if (now) now.hidden = true; return; }
    current = v; idSel.value = v.id;
    showPrice();
    add.disabled = !v.available; if (v.available) setAddLabel(); else add.textContent = 'Sold out';
    if (now) now.hidden = !v.available;
    if (selLine) selLine.innerHTML = (single ? '' : 'Selected: <b>' + esc(v.title) + '</b>') + (v.sku ? (single ? '' : ' · ') + 'SKU ' + esc(v.sku) : '');
    var ss = $('[data-rfc-spec-sel]'); if (ss) ss.textContent = v.title;
    var sk = $('[data-rfc-spec-sku]'); if (sk) sk.textContent = v.sku || '—';
    var po = $('[data-rfc-pq-opt]'); if (po) po.value = v.title;
    var psk = $('[data-rfc-pq-sku]'); if (psk) psk.value = v.sku || '';
    if (sAdd) sAdd.disabled = !v.available;
    if (pushUrl) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {} }
    var ref = $('[data-rfc-ref]');
    if (ref) ref.hidden = true;
    if (v.featured_media) { if (!drawOn) showSlide('m' + v.featured_media.id); }
    else if (ref && !single && $$('[data-rfc-zoom]').length && /colou?r|finish/i.test(optNames.join(' '))) { ref.hidden = false; ref.textContent = 'Photos show the product in general — they may not show ' + v.title + '.'; }
    draw(); plan(); setAddLabel(); prefill();
  };
  box.addEventListener('click', function (e) {
    var b = e.target.closest('.rfc-pill'); if (!b || b.getAttribute('aria-disabled') === 'true') return;
    var i = +b.getAttribute('data-o'), o = opts[i];
    if (b.hasAttribute('data-v')) sel[i] = b.getAttribute('data-v');
    else {
      var cur = pair(sel[i]) || [], a = cur[0], bb = cur[1];
      if (b.hasAttribute('data-a')) a = +b.getAttribute('data-a'); else bb = +b.getAttribute('data-b');
      var exact = o.vals.filter(function (v) { var p = pair(v); return p[0] === a && p[1] === bb; })[0];
      if (!exact) exact = o.vals.filter(function (v) { var p = pair(v); return p[0] === a; })[0];
      sel[i] = exact;
    }
    if (!findV()) { var fb = variants.filter(function (x) { return x.options[i] === sel[i]; })[0]; if (fb) sel = fb.options.slice(); }
    render(); update(true);
  });

  /* VAT switch */
  $$('[data-rfc-vat]').forEach(function (b, _, all) {
    b.addEventListener('click', function () {
      vatMode = b.getAttribute('data-rfc-vat');
      all.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      showPrice();
    });
  });

  /* gallery */
  var slides = $$('.rfc-pgal__s'), thumbs = $$('[data-show]'), drawOn = false;
  var visSlides = function () { return slides.filter(function (s) { return !s.hidden; }); };
  var curSlide = function () { return visSlides().filter(function (s) { return s.classList.contains('is-on'); })[0]; };
  var step = function (d) { var vs = visSlides(), i = vs.indexOf(curSlide()); if (!vs.length) return; i = (i + d + vs.length) % vs.length; showSlide(vs[i].getAttribute('data-slide')); };
  var showSlide = function (k) {
    if (!slides.some(function (s) { return s.getAttribute('data-slide') === k; })) return;
    slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === k); });
    thumbs.forEach(function (t) { var on = t.getAttribute('data-show') === k; t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  };
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.getAttribute('data-show')); }); });
  $$('[data-rfc-gnav]').forEach(function (b) { b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-rfc-gnav'), 10)); }); });
  var stage = $('[data-rfc-stage]'), tx = null, ty = null;
  if (stage) {
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; tx = t.clientX; ty = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (tx == null) return; var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
  /* lightbox */
  var lb = $('[data-rfc-lb]'), lbImg = lb && lb.querySelector('[data-rfc-lb-img]'), zooms = $$('[data-rfc-zoom]'), lbI = 0, lbFrom = null;
  var lbShow = function (i) {
    lbI = (i + zooms.length) % zooms.length; var z = zooms[lbI], im = z.querySelector('img');
    lbImg.src = z.getAttribute('data-full'); lbImg.alt = im ? im.alt : '';
    var c = lb.querySelector('[data-rfc-lb-count]'); if (c) c.textContent = 'Photo ' + (lbI + 1) + ' of ' + zooms.length;
  };
  var lbClose = function () { if (lb.hidden) return; lb.hidden = true; document.documentElement.style.overflow = ''; if (lbFrom) lbFrom.focus(); };
  if (lb && zooms.length) {
    zooms.forEach(function (z, i) { z.addEventListener('click', function () { lbFrom = z; lb.hidden = false; document.documentElement.style.overflow = 'hidden'; lbShow(i); lb.querySelector('[data-rfc-lb-close]').focus(); }); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-rfc-lb-close]')) lbClose(); var n = e.target.closest('[data-rfc-lb-nav]'); if (n) lbShow(lbI + parseInt(n.getAttribute('data-rfc-lb-nav'), 10)); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
      else if (e.key === 'ArrowRight' && zooms.length > 1) lbShow(lbI + 1);
      else if (e.key === 'ArrowLeft' && zooms.length > 1) lbShow(lbI - 1);
      else if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(lb.querySelectorAll('button')); if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    var lx = null; lb.addEventListener('touchstart', function (e) { lx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { if (lx == null) return; var dx = e.changedTouches[0].clientX - lx; lx = null; if (Math.abs(dx) > 50 && zooms.length > 1) lbShow(lbI + (dx < 0 ? 1 : -1)); }, { passive: true });
  }

  /* drawings (hoop barriers) */
  var dims = function () { var o = opts.filter(function (x) { return x.split; })[0]; return o ? pair(sel[o.i]) : null; };
  var hoopPath = function (cx, w, h, g, r) {
    var x0 = cx - w / 2, x1 = cx + w / 2, top = g - h; r = Math.min(r, w / 3, h / 2);
    return 'M' + x0 + ' ' + g + 'V' + (top + r) + 'Q' + x0 + ' ' + top + ' ' + (x0 + r) + ' ' + top + 'H' + (x1 - r) + 'Q' + x1 + ' ' + top + ' ' + x1 + ' ' + (top + r) + 'V' + g;
  };
  var svg = $('[data-rfc-draw]'), ctx = $('[data-rfc-ctx]');
  var draw = function () {
    if (!svg) return;
    var d = dims();
    var slide = $('[data-rfc-draw-slide]'), btn = $('[data-rfc-draw-btn]'), cs = $('[data-rfc-ctx-slide]'), cb = $('[data-rfc-ctx-btn]');
    if (!d) { [slide, cs].forEach(function (x) { if (x) { x.hidden = true; x.classList.remove('is-on'); } }); [btn, cb].forEach(function (x) { if (x) x.hidden = true; }); return; }
    if (slide && slide.hidden) { slide.hidden = false; btn.hidden = false; if (cs) { cs.hidden = false; cb.hidden = false; } drawOn = true; showSlide('draw'); }
    var sc = 0.14, H = d[0], L = d[1], g = 214;
    var w = L * sc, h = H * sc, x0 = 200 - w / 2, x1 = 200 + w / 2, top = g - h, r = 22;
    svg.querySelector('[data-rfc-hoop]').setAttribute('d', hoopPath(200, w, h, g, r));
    svg.querySelector('[data-rfc-hoop-hl]').setAttribute('d', 'M' + (x0 - 2) + ' ' + (g - 4) + 'V' + (top + Math.min(r, w / 3, h / 2)));
    svg.querySelector('[data-rfc-plates]').innerHTML = '<rect x="' + (x0 - 12) + '" y="' + (g - 4) + '" width="24" height="5" rx="1"/><rect x="' + (x1 - 12) + '" y="' + (g - 4) + '" width="24" height="5" rx="1"/>';
    svg.querySelector('[data-rfc-tube]').setAttribute('y', Math.max(14, top - 14));
    var hd = svg.querySelector('[data-rfc-hdim]'), hx = x0 - 26;
    hd.querySelector('path').setAttribute('d', 'M' + hx + ' ' + top + 'V' + g + 'M' + (hx - 6) + ' ' + top + 'H' + (hx + 6) + 'M' + (hx - 6) + ' ' + g + 'H' + (hx + 6));
    var ht = 'H ' + H + 'mm', hw = ht.length * 7 + 14;
    hd.querySelector('rect').setAttribute('x', hx - hw - 4); hd.querySelector('rect').setAttribute('y', top + h / 2 - 10); hd.querySelector('rect').setAttribute('width', hw);
    var t1 = hd.querySelector('text'); t1.setAttribute('x', hx - hw / 2 - 4); t1.setAttribute('y', top + h / 2 + 4); t1.textContent = ht;
    var ld = svg.querySelector('[data-rfc-ldim]'), ly = g + 22;
    ld.querySelector('path').setAttribute('d', 'M' + x0 + ' ' + ly + 'H' + x1 + 'M' + x0 + ' ' + (ly - 6) + 'V' + (ly + 6) + 'M' + x1 + ' ' + (ly - 6) + 'V' + (ly + 6));
    var lt = 'L ' + L + 'mm', lw = lt.length * 7 + 14;
    ld.querySelector('rect').setAttribute('x', 200 - lw / 2); ld.querySelector('rect').setAttribute('y', ly + 6); ld.querySelector('rect').setAttribute('width', lw);
    var t2 = ld.querySelector('text'); t2.setAttribute('x', 200); t2.setAttribute('y', ly + 20); t2.textContent = lt;
    if (ctx) {
      var s2 = 0.1, ph = 1750 * s2, px = 110;
      var hy = g - ph, bw = 26;
      ctx.querySelector('[data-rfc-person]').innerHTML = '<circle cx="' + px + '" cy="' + (hy + 11) + '" r="11"/><rect x="' + (px - bw / 2) + '" y="' + (hy + 25) + '" width="' + bw + '" height="' + (ph * 0.42) + '" rx="8"/><rect x="' + (px - bw / 2) + '" y="' + (hy + 25 + ph * 0.38) + '" width="11" height="' + (g - (hy + 25 + ph * 0.38)) + '" rx="4"/><rect x="' + (px + bw / 2 - 11) + '" y="' + (hy + 25 + ph * 0.38) + '" width="11" height="' + (g - (hy + 25 + ph * 0.38)) + '" rx="4"/>';
      ctx.querySelector('[data-rfc-hoop2]').setAttribute('d', hoopPath(250, L * s2, H * s2, g, 12));
      ctx.querySelector('[data-rfc-ctxt]').textContent = H + 'mm hoop next to a 1.75m person';
    }
  };

  /* how many do I need */
  var planBox = $('[data-rfc-plan]'), run = $('[data-rfc-run]'), gap = $('[data-rfc-gap]');
  var unitLen = function () {
    var d = dims(); if (d) return d[1];
    for (var i = 0; i < opts.length; i++) { if (/length|width/i.test(opts[i].name)) { var l = lenOf(sel[i]); if (l) return l; } }
    return null;
  };
  var need = 0;
  var plan = function () {
    if (!planBox) return;
    var l = unitLen();
    if (!l) { planBox.hidden = true; return; }
    planBox.hidden = false;
    var r = parseFloat(run.value), gp = Math.max(0, parseFloat(gap.value) || 0);
    var out = $('[data-rfc-plan-out]'), vis = $('[data-rfc-vis]');
    if (!(r > 0)) { out.textContent = ''; vis.innerHTML = ''; return; }
    need = Math.max(1, Math.ceil((r * 1000 + gp) / (l + gp) - 1e-9));
    var cover = (need * l + (need - 1) * gp) / 1000;
    $('[data-rfc-need]').textContent = need;
    out.textContent = need + ' × ' + fmtM(l) + (gp ? ' with ' + gp + 'mm gaps' : ' end to end') + ' covers ' + (+cover.toFixed(2)) + 'm. Estimate only — check on site.';
    var k = Math.min(need, 24), g = '';
    for (var j = 0; j < k; j++) g += '<i' + (gp ? ' class="has-gap"' : '') + '></i>';
    vis.innerHTML = g + (need > k ? '<b>+' + (need - k) + '</b>' : '');
  };
  [run, gap].forEach(function (x) { if (x) x.addEventListener('input', function () { plan(); prefill(); }); });
  var use = $('[data-rfc-use]'); if (use) use.addEventListener('click', function () { if (need > 0) { qty.value = need; setAddLabel(); prefill(); qty.focus(); } });

  /* project quote prefill */
  var pre = $('[data-rfc-pre]'), pqQty = $('[data-rfc-pq-qty]'), pqCol = $('[data-rfc-pq-col]');
  [pqQty, pqCol].forEach(function (f) { if (f) f.addEventListener('input', function () { f.setAttribute('data-edited', '1'); }); });
  var prefill = function () {
    if (!current) return;
    var q = qn();
    var bits = product.title + (single ? '' : ' · ' + current.title) + (current.sku ? ' · SKU ' + current.sku : '') + ' · Qty ' + q;
    if (planBox && !planBox.hidden && run && parseFloat(run.value) > 0) bits += ' for ' + run.value + 'm';
    if (pre) { pre.hidden = false; $('[data-rfc-pre-v]').textContent = bits; }
    if (pqQty && !pqQty.hasAttribute('data-edited')) pqQty.value = q;
    if (pqCol && !pqCol.hasAttribute('data-edited')) pqCol.value = single ? '' : current.title;
  };
  var pqf = document.getElementById('rfc-pdp-quote');
  if (pqf) pqf.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var b = pqf.querySelector('[data-rfc-pq-send]'); if (!b) return;
    if (b.getAttribute('aria-busy') === 'true') { e.preventDefault(); return; }
    b.setAttribute('aria-busy', 'true'); b.textContent = 'Sending…'; setTimeout(function () { b.disabled = true; }, 0);
  });
  $$('[data-rfc-to-quote]').forEach(function (a) { a.addEventListener('click', function () { var f = document.getElementById('rfc-qq-n'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 450); }); });

  /* qty + buy now + print */
  var qErr = $('[data-rfc-qty-err]');
  var checkQty = function () {
    var raw = qty.value, n = Number(raw), ok = raw !== '' && Number.isInteger(n) && n >= 1 && n <= 999;
    if (qErr) { qErr.hidden = ok; qErr.textContent = ok ? '' : 'Enter a whole number from 1 to 999.'; }
    if (ok) qty.removeAttribute('aria-invalid'); else qty.setAttribute('aria-invalid', 'true');
    return ok;
  };
  $$('[data-rfc-step]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.min(999, Math.max(1, qn() + parseInt(b.getAttribute('data-rfc-step'), 10))); checkQty(); setAddLabel(); prefill(); }); });
  qty.addEventListener('input', function () { checkQty(); setAddLabel(); prefill(); });
  qty.addEventListener('blur', function () { if (!checkQty()) { qty.value = qn(); checkQty(); setAddLabel(); prefill(); } });
  var ret = $('[data-rfc-return]');
  if (now && ret) { now.addEventListener('click', function () { ret.disabled = false; }); add.addEventListener('click', function () { ret.disabled = true; }); }

  /* add to basket: /cart/add.js with busy, success and error states; Buy it now keeps the normal checkout post */
  var form = document.getElementById('rfc-pf'), msgBox = $('[data-rfc-msg]');
  var say = function (html, kind) { if (!msgBox) return; msgBox.hidden = false; msgBox.className = 'rfc-pf__msg is-' + kind; msgBox.innerHTML = html; };
  var setBusy = function (on) {
    busy = on; add.disabled = on || !(current && current.available); add.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) add.innerHTML = '<span>Adding…</span>'; setAddLabel();
    if (sAdd) { sAdd.disabled = on || !(current && current.available); if (on) sAdd.textContent = 'Adding…'; }
  };
  var doAdd = function () {
    if (busy || !current || !current.available) return;
    if (!checkQty()) { qty.focus(); return; }
    if (!window.fetch) { form.submit(); return; }
    setBusy(true); if (msgBox) msgBox.hidden = true;
    var fd = new FormData(form); fd.delete('return_to'); fd.set('id', current.id); fd.set('quantity', qn());
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'This item could not be added.');
        say('<b>Added ' + qn() + ' × ' + esc(product.title) + (single ? '' : ' (' + esc(current.title) + ')') + ' to your basket.</b> <a href="/cart">View basket</a>', 'ok');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.rfc-cart b').forEach(function (b) { b.textContent = c.item_count; });
          document.querySelectorAll('a.rfc-cart').forEach(function (a) { a.setAttribute('aria-label', 'Basket, ' + c.item_count + ' item' + (c.item_count === 1 ? '' : 's')); });
        }).catch(function () {});
      })
      .catch(function (err) { say('<b>Not added.</b> ' + esc(err.message || 'Please try again.'), 'err'); })
      .then(function () { setBusy(false); });
  };
  if (form) form.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.hasAttribute('data-rfc-now')) { if (!checkQty()) { e.preventDefault(); qty.focus(); } return; }
    e.preventDefault(); doAdd();
  });

  /* phone quick-buy bar: shows once the main buy row has scrolled away; hides near the quote form and footer, and while typing */
  var row = $('[data-rfc-buyrow]');
  if (sbar && row) {
    var mq = window.matchMedia('(max-width: 749px)'), tick = false;
    var hideZones = [document.getElementById('rfc-pq'), document.querySelector('.rfc-foot')].filter(Boolean);
    var check = function () {
      tick = false;
      var r = row.getBoundingClientRect(), vh = window.innerHeight;
      var typing = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) && !document.activeElement.closest('[data-rfc-sbar]');
      var inZone = hideZones.some(function (z) { var q = z.getBoundingClientRect(); return q.top < vh && q.bottom > 0; });
      var show = mq.matches && r.bottom < 0 && !inZone && !typing && (!lb || lb.hidden);
      sbar.hidden = !show; document.documentElement.classList.toggle('rfc-sbar-on', show);
    };
    var on = function () { if (!tick) { tick = true; requestAnimationFrame(check); } };
    window.addEventListener('scroll', on, { passive: true }); window.addEventListener('resize', on);
    document.addEventListener('focusin', on); document.addEventListener('focusout', function () { setTimeout(on, 50); });
    if (sAdd) sAdd.addEventListener('click', doAdd);
    var ch = sbar.querySelector('[data-rfc-sbar-change]');
    if (ch) ch.addEventListener('click', function (e) { e.preventDefault(); var t = document.getElementById('rfc-buy'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); var f = $('.rfc-pill.is-on') || qty; setTimeout(function () { f.focus({ preventScroll: true }); }, 400); });
    check();
  }

  /* on-page tabs: show a scroll cue when more links are off to the right */
  var tabs = $('[data-rfc-ptabs]');
  if (tabs) {
    var ul = tabs.querySelector('ul');
    var cue = function () { tabs.classList.toggle('has-more', ul.scrollWidth - ul.clientWidth - ul.scrollLeft > 4); };
    ul.addEventListener('scroll', cue, { passive: true }); window.addEventListener('resize', cue); cue();
  }
  var pr = $('[data-rfc-print]'); if (pr) pr.addEventListener('click', function () { window.print(); });

  /* boot */
  var fb = $('[data-rfc-fallback]'); if (fb) fb.hidden = true;
  render(); update(false);
  if (!drawOn && slides.length && !slides.some(function (s) { return s.classList.contains('is-on') && !s.hidden; })) {
    var firstPhoto = slides.filter(function (s) { return !s.hidden; })[0]; if (firstPhoto) showSlide(firstPhoto.getAttribute('data-slide'));
  }
})();

/* cart page: qty auto-update, save for later, VAT switch, references, discount code, share link, print, project quote, recommendations */
(function () {
  var root = document.querySelector('[data-rfc-cart]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = root.getAttribute('data-money') || '£{{amount}}';
  var money = function (c) {
    var n = (c / 100).toFixed(2).split('.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]).split(' (')[0].split(' Inc')[0].split(' inc')[0];
  };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var post = function (url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw r; return r.json(); }); };
  var reload = function () { location.reload(); };

  /* quantity: debounce then /cart/change.js; busy + status text, errors shown on the line (old quantity restored) */
  var timers = {};
  $$('.rfc-line').forEach(function (li) {
    var line = +li.getAttribute('data-line'), input = $('[data-rfc-cqty]', li), st = $('[data-rfc-line-st]', li);
    var prev = input.value;
    var status = function (t, err) { if (!st) return; st.hidden = !t; st.textContent = t || ''; st.classList.toggle('is-err', !!err); };
    var lock = function (on) { li.classList.toggle('is-busy', on); li.setAttribute('aria-busy', on ? 'true' : 'false'); $$('button, input', li).forEach(function (c) { c.disabled = on; }); };
    var push = function () {
      clearTimeout(timers[line]);
      var q = parseInt(input.value, 10);
      if (!(q >= 0) || String(q) !== String(input.value).trim()) { status('Enter a whole number (0 removes the item).', true); input.value = prev; return; }
      timers[line] = setTimeout(function () {
        lock(true); status(q === 0 ? 'Removing…' : 'Updating…');
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: q }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not update this item.');
            reload();
          })
          .catch(function (err) { lock(false); input.value = prev; status((err && err.message) || 'Could not update this item. Please try again.', true); });
      }, 500);
    };
    var rm = $('[data-rfc-remove]', li);
    if (rm) rm.addEventListener('click', function () { lock(true); status('Removing…'); });
    $$('[data-rfc-cstep]', li).forEach(function (b) { b.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-rfc-cstep'), 10)); push(); }); });
    input.addEventListener('change', push);
    var save = $('[data-rfc-save]', li);
    if (save) save.addEventListener('click', function () {
      var item = { id: li.getAttribute('data-variant'), title: li.getAttribute('data-title'), v: li.getAttribute('data-vtitle'), url: li.getAttribute('data-url'), img: li.getAttribute('data-img'), price: +li.getAttribute('data-price'), qty: parseInt(input.value, 10) || 1 };
      try { var list = JSON.parse(localStorage.getItem('rfc-saved') || '[]').filter(function (x) { return x.id !== item.id; }); list.unshift(item); localStorage.setItem('rfc-saved', JSON.stringify(list.slice(0, 20))); } catch (e) {}
      li.classList.add('is-busy');
      post('/cart/change.js', { line: line, quantity: 0 }).then(reload).catch(reload);
    });
  });

  /* saved for later list */
  var savedBox = $('[data-rfc-saved]');
  var renderSaved = function () {
    if (!savedBox) return;
    var list = []; try { list = JSON.parse(localStorage.getItem('rfc-saved') || '[]'); } catch (e) {}
    if (!list.length) { savedBox.hidden = true; return; }
    savedBox.hidden = false;
    $('[data-rfc-saved-list]', savedBox).innerHTML = list.map(function (x, i) {
      return '<li><a class="rfc-saved__img" href="' + esc(x.url) + '">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a><div><a href="' + esc(x.url) + '"><b>' + esc(x.title) + '</b></a>' + (x.v ? '<small>' + esc(x.v) + '</small>' : '') + '</div><button type="button" class="rfc-btn rfc-btn--dark rfc-btn--sm" data-move="' + i + '">Move to basket</button><button type="button" class="rfc-link" data-drop="' + i + '">Remove</button></li>';
    }).join('');
  };
  if (savedBox) savedBox.addEventListener('click', function (e) {
    var mv = e.target.closest('[data-move]'), dr = e.target.closest('[data-drop]');
    if (!mv && !dr) return;
    var list = []; try { list = JSON.parse(localStorage.getItem('rfc-saved') || '[]'); } catch (er) {}
    var i = +(mv || dr).getAttribute(mv ? 'data-move' : 'data-drop'), it = list[i];
    list.splice(i, 1); try { localStorage.setItem('rfc-saved', JSON.stringify(list)); } catch (er) {}
    if (mv && it) post('/cart/add.js', { items: [{ id: +it.id, quantity: it.qty || 1 }] }).then(reload).catch(function () { location.href = it.url; });
    else renderSaved();
  });
  renderSaved();

  /* VAT switch on line prices */
  $$('[data-rfc-cvat]').forEach(function (b, _, all) {
    b.addEventListener('click', function () {
      var ex = b.getAttribute('data-rfc-cvat') === 'ex';
      all.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      $$('[data-rfc-money]').forEach(function (el) { var c = +el.getAttribute('data-rfc-money'); el.textContent = money(ex ? Math.round(c / 1.2) : c) + (ex ? ' ex VAT' : ''); });
    });
  });

  /* references → cart attributes / note (saved as you type) */
  var refT;
  $$('[data-rfc-attr]').forEach(function (el) {
    el.addEventListener('input', function () {
      clearTimeout(refT);
      refT = setTimeout(function () {
        post('/cart/update.js', { note: ($('#rfc-note') || {}).value || '', attributes: { 'PO number': ($('#rfc-po') || {}).value || '', 'Site name': ($('#rfc-site') || {}).value || '' } }).catch(function () {});
      }, 600);
    });
  });

  /* discount code */
  var code = $('[data-rfc-code]'), apply = $('[data-rfc-apply]');
  var go = function () { var c = (code.value || '').trim(); if (c) location.href = '/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent('/cart'); };
  if (apply) apply.addEventListener('click', go);
  if (code) code.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });

  /* share basket link (cart permalink) */
  var share = $('[data-rfc-share]');
  if (share) share.addEventListener('click', function () {
    var parts = $$('.rfc-line').map(function (li) { return li.getAttribute('data-variant') + ':' + (parseInt($('[data-rfc-cqty]', li).value, 10) || 1); });
    var url = location.origin + '/cart/' + parts.join(',') + '?storefront=true';
    var msg = $('[data-rfc-share-msg]');
    var done = function () { if (msg) msg.textContent = 'Link copied — paste it to a colleague'; };
    if (navigator.share) { navigator.share({ title: 'Basket', url: url }).catch(function () {}); }
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
    else window.prompt('Copy this link', url);
  });

  /* print as PDF quote */
  var pr = $('[data-rfc-print-cart]'); if (pr) pr.addEventListener('click', function () { document.documentElement.classList.add('rfc-printing'); window.print(); setTimeout(function () { document.documentElement.classList.remove('rfc-printing'); }, 500); });

  /* project quote panel */
  var po = $('[data-rfc-proj-open]'), pb = $('[data-rfc-proj]');
  if (po && pb) po.addEventListener('click', function () { pb.hidden = false; po.setAttribute('aria-expanded', 'true'); pb.scrollIntoView({ behavior: 'smooth', block: 'start' }); var f = pb.querySelector('input:not([type=hidden])'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400); });
  if (pb && pb.querySelector('.rfc-ok, .rfc-err')) pb.hidden = false;

  /* complete the job: related products for the first basket items */
  var cx = $('[data-rfc-cx]');
  if (cx && window.fetch) {
    var ids = (cx.getAttribute('data-ids') || '').split(',').filter(Boolean);
    var inCart = ids.map(Number), seen = {};
    Promise.all(ids.slice(0, 3).map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=6&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
    })).then(function (res) {
      var out = [];
      res.forEach(function (r) { (r.products || []).forEach(function (p) { if (inCart.indexOf(p.id) < 0 && !seen[p.id] && out.length < 3) { seen[p.id] = 1; out.push(p); } }); });
      if (!out.length) return;
      $('[data-rfc-cx-list]', cx).innerHTML = out.map(function (p) {
        var single = p.variants && p.variants.length === 1;
        var img = p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src) : '';
        if (img) img = img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=200';
        return '<li class="rfc-cxc"><a class="rfc-cxc__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</a><div>' + (p.type ? '<p class="rfc-cxc__k">' + esc(p.type) + '</p>' : '') + '<h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="rfc-cxc__ft"><b>' + (p.price_varies ? 'From ' : '') + money(p.price) + '</b>' + (single && p.available ? '<button type="button" class="rfc-btn rfc-btn--dark rfc-btn--sm" data-cx-add="' + p.variants[0].id + '">Add</button>' : '<a class="rfc-btn rfc-btn--line rfc-btn--sm" href="' + esc(p.url) + '">Choose options</a>') + '</div></div></li>';
      }).join('');
      cx.hidden = false;
    });
    cx.addEventListener('click', function (e) { var b = e.target.closest('[data-cx-add]'); if (!b) return; b.disabled = true; post('/cart/add.js', { items: [{ id: +b.getAttribute('data-cx-add'), quantity: 1 }] }).then(reload).catch(reload); });
  }

  /* phone/tablet checkout bar: shows while the summary's checkout button is off screen; hides at the summary, footer and while typing */
  var cbar = $('[data-rfc-cbar]'), goBtn = $('.rfc-sum__go');
  if (cbar && goBtn) {
    var mq = window.matchMedia('(max-width: 989px)'), tk = false;
    var zones = [document.querySelector('.rfc-foot'), $('[data-rfc-proj]')].filter(Boolean);
    var chk = function () {
      tk = false;
      var r = goBtn.getBoundingClientRect(), vh = window.innerHeight;
      var goVisible = r.top < vh && r.bottom > 0;
      var typing = document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
      var inZone = zones.some(function (z) { if (z.hidden) return false; var q = z.getBoundingClientRect(); return q.top < vh && q.bottom > 0; });
      var show = mq.matches && !goVisible && !inZone && !typing;
      cbar.hidden = !show; document.documentElement.classList.toggle('rfc-cbar-on', show);
    };
    var on = function () { if (!tk) { tk = true; requestAnimationFrame(chk); } };
    window.addEventListener('scroll', on, { passive: true }); window.addEventListener('resize', on);
    document.addEventListener('focusin', on); document.addEventListener('focusout', function () { setTimeout(on, 50); });
    chk();
  }

  /* quote result into view */
  var ok = root.querySelector('[data-rfc-focus]'); if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
})();
